import Script from 'next/script';

/**
 * Gladly `appId` — copy the value from Gladly Admin:
 * Settings → Channels → Chat → open your Chat → Embed → **Initialize chat** snippet
 * (`window.gladlyConfig = { appId: '…' }`). It is not secret (it ships in the browser).
 *
 * Change this string if Gladly gives you a new Chat embed id.
 */
const GLADLY_APP_ID = 'soothe.com-urban1web-';

/**
 * Official Gladly “Load Chat” bootstrap with the 4th argument hardcoded to `'PROD'`.
 * Production Chat configs live on `cdn.gladly.com`; `STAGING` would hit `cdn.gladly.qa` and 404 for this appId.
 */
const GLADLY_PROD_BOOTSTRAP = `!function(c,n,r,t){if(!c[r]){var i,d,p=[];d="PROD"!==t&&t?"STAGING"===t?"https://cdn.gladly.qa/gladly/chat-sdk/widget.js":t:"https://cdn.gladly.com/chat-sdk/widget.js",c[r]={init:function(){i=arguments;var e={then:function(t){return p.push({type:"t",next:t}),e},catch:function(t){return p.push({type:"c",next:t}),e}};return e}},c.__onHelpAppHostReady__=function(t){if(delete c.__onHelpAppHostReady__,(c[r]=t).loaderCdn=d,i)for(var e=t.init.apply(t,i),n=0;n<p.length;n++){var a=p[n];e="t"===a.type?e.then(a.next):e.catch(a.next)}},function(){try{var t=n.getElementsByTagName("script")[0],e=n.createElement("script");e.async=!0,e.src=d+"?q="+(new Date).getTime(),t.parentNode.insertBefore(e,t)}catch(t){}}()}}(window,document,'Gladly','PROD')`;

export const GladlyChat = () => {
  const appId = GLADLY_APP_ID.trim();
  if (!appId) {
    return null;
  }

  const initSnippet = `window.gladlyConfig = { appId: ${JSON.stringify(appId)} };`;
  const combinedSnippet = `${initSnippet}\n${GLADLY_PROD_BOOTSTRAP}`;

  return (
    <Script
      id="gladly-web-chat"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{ __html: combinedSnippet }}
    />
  );
};
